var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99793 0.500002C10.2545 0.499474 10.5113 0.597104 10.7071 0.792893L15.2071 5.29289C15.5976 5.68342 15.5976 6.31658 15.2071 6.70711C14.8166 7.09763 14.1834 7.09763 13.7929 6.70711L10.9958 3.91006V14.5C10.9958 15.0523 10.5481 15.5 9.99585 15.5C9.44356 15.5 8.99585 15.0523 8.99585 14.5V3.91836L6.20711 6.70711C5.81658 7.09763 5.18342 7.09763 4.79289 6.70711C4.40237 6.31658 4.40237 5.68342 4.79289 5.29289L9.23652 0.849271C9.41992 0.63546 9.69206 0.5 9.99585 0.5C9.99654 0.5 9.99724 0.500001 9.99793 0.500002ZM19 9.5C19.5523 9.5 20 9.94771 20 10.5V19.5C20 20.0523 19.5523 20.5 19 20.5H1C0.447715 20.5 0 20.0523 0 19.5V10.5042C0 9.95187 0.447715 9.50415 1 9.50415C1.55228 9.50415 2 9.95187 2 10.5042V18.5H18V10.5C18 9.94771 18.4477 9.5 19 9.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.473bce2c5c44854aa416ba4f8d761074.svg";
export { ForwardRef as ReactComponent };